<template>
  <v-card
    class="rdatabrandcard box-shadow-custom"
    max-width="240"
  >
    <div class="pa-4">
      <div class="rdatabrandcard--header d-flex mb-2">
        <span
          class="rdatabrandcard--title text-truncate"
          :title="name"
        >{{ name }}</span>
        <v-icon class="rdatabrandcard--icon ml-2">
          {{ DASHBOARD_TYPE_TO_ICON[DASHBOARD_TYPES.BRAND] }}
        </v-icon>
      </div>

      <div class="rdatabrandcard--body d-flex">
        <div class="flex-expand">
          <p class="rdatabrandcard--numproducts mb-1">
            {{ numProducts !== 1 ?
              $t('resources.productCount', { numProducts }) : '1' + $t('resources.product') }}
          </p>
          <p class="rdatabrandcard--numurls mb-0">
            {{ numUrls !== 1 ?
              $t('resources.urlCount', { numUrls }) : '1' + $t('resources.url') }}
          </p>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import { DASHBOARD_TYPES, RESOURCE_TYPE_TO_ICON } from '@/utils/constants'

export default {
  name: 'RDataBrandCard',
  props: {
    name: {
      type: String,
      required: true,
    },
    numProducts: {
      type: Number,
      default: 0,
    },
    numUrls: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    DASHBOARD_TYPES,
    DASHBOARD_TYPE_TO_ICON: RESOURCE_TYPE_TO_ICON,
  }),
}
</script>

<style scoped>
.rdatabrandcard--title {
  flex: 1 1 auto;
  font-size: 12px;
  font-weight: 700;
}
.rdatabrandcard--icon {
  flex: 0 0;
}
/deep/ .rdatabrandcard--footer .v-icon {
  margin-top: -2px;
}
.rdatabrandcard--body p {
  font-size: 12px;
}
.flex-expand {
  flex: 1;
}
</style>
